module.exports = __webpack_public_path__ + "media/images/forms-icons/separator-icon-aa7d302eab1064766abf2c4042d0348d.svg";